var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.709,
    height: 12.042,
    viewBox: "0 0 6.709 12.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2898",
    "data-name": "Trac\\xE9 2898",
    d: "M1589.163,623.667l5.132,5.568-5.132,5.451",
    transform: "translate(-1588.611 -623.159)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.94aa9748a94763e7b27b2b31ab09e006.svg";
export { ForwardRef as ReactComponent };